import { LoadingPage } from '@/components/ui/loading';
import { useUsersPage } from '../hooks/use-users-page';
import { UsersView } from './users-view';

export function UsersPage() {
  const state = useUsersPage();
  if (state.loading) return <LoadingPage />;
  return <UsersView state={state} />;
}
